var map = {
	"./About.jpg": 7562,
	"./Billgates.png": 6597,
	"./Brand.png": 6246,
	"./Contact.jpg": 6925,
	"./Elonmusk.png": 9701,
	"./GaleryFive.jpg": 7919,
	"./GaleryFour.jpg": 5216,
	"./GaleryOne.jpg": 1548,
	"./GalerySix.jpg": 429,
	"./GaleryThree.jpg": 406,
	"./GaleryTwo.jpg": 6779,
	"./Hero.png": 3808,
	"./Heros.png": 9945,
	"./Mark.png": 308,
	"./Skill.jpg": 9930,
	"./Skills.jpg": 9667
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5459;